/* eslint-disable */
/**
 * Function that retrieves the value from the URL for a given key.
 *
 * @param {*} key Speicfic key in the URL to obtain the value from.
 * @returns value for key if present, false otherwise.
 */
 const getUrlVar = (key) => {
  let vars = {};
  const url = window.location.href.replace('#', '').replace('!', '');
  let parts = url.replace(/[?&]+([^=&]+)=([^&]*)/gi,
  function(m,key,value) {
    vars[key] = value;
  });
  return (vars[key]) ? vars[key] : false;
};

/**
 * Function that constructs the error options for the root Playposit error screen.
 * 
 * @param {Object} error Options object to construct error optionsn from.
 */
const constructOptionsFromError = (error) => {
  const ERR = error.response || error;
  let error_options = {};
  error_options.icon = 'error';
  error_options.code = ERR.status || 500;
  error_options.title = (() => {
    if (ERR.status === 400) return `Bad request.`;
    if (ERR.status === 401) return `Unauthorized.`;
    if (ERR.status === 403) return `Forbidden.`;
    if (ERR.status === 404) return `Not found.`;
    if (ERR.status === 500) return `Internal server error.`;
    if (ERR.status === 502) return `Bad gateway.`;
    else if (error.toString()) return error.toString().replace('Error:', '').trim()
    return `Error`;
  })();
  error_options.text = (() => {
    if (ERR.message) return ERR.message;
    if (ERR.msg) return ERR.msg;
    if (ERR.data) {
      if (ERR.data.message) return ERR.data.message;
      if (ERR.data.msg) return ERR.data.msg;
      if (ERR.data.data) return ERR.data.data;
    }
    return '';
  })();
  if (ERR.status === 401) {
    error_options.buttons = [{
      text: 'login',
      action: 'https://www.playposit.com/login'
    }];
    if (!error_options.text) error_options.text = 'Error authenticating the user. Please login again.'
  } else if (ERR.status === 403) {
    error_options.icon = 'pan_tool';
  } else if (ERR.status === 404) {
    if (optionsDefaults.environment.includes('designer') && getUrlVar('token')) {
      error_options.buttons = [
        {
          text: 'Create a new bulb',
          order: 0,
          action: `${window.location.origin}${window.location.pathname}?bulb_id=new&token=${getUrlVar('token')}`
        },
        {
          text: 'Back',
          order: 1,
          type: 'outline',
          action: 'return'
        }
      ];
    } else {
      error_options.buttons = [{
        text: 'Back',
        type: 'outline',
        action: 'return'
      }];
    }
  }
  return error_options;
};

/**
 * Function that constructs the main options object for the root Playposit error screen.
 * 
 * @param {Object} opts Passed in options object.
 * @returns constructed options object.
 */
const constructOpts = opts => {
  if (!opts.text && opts.message) opts.text = opts.message;
  if (!opts.text && opts.details) opts.text = opts.details;
  if (!opts.text && opts.msg) opts.text = opts.msg;
  if (opts instanceof Error) {
    return constructOptionsFromError(opts);
  } else if (typeof opts === 'string') {
    return {
      title: opts
    };
  } else {
    return opts;
  }
}

// Export the constructed options for the main root Playposit error screen:
export default constructOpts;